(function () {
  function normalizeError(error) {
    if (!error) return '';
    if (typeof error === 'string') return error;
    if (error.message) return error.message;
    if (error.description) return error.description;
    return String(error);
  }

  function resolveCartErrorMessage(error) {
    const raw = normalizeError(error).toLowerCase();
    const strings = window.cartStrings || {};

    if (
      raw.includes('422') ||
      raw.includes('too many requests') ||
      raw.includes('rate limit') ||
      raw.includes('demasiadas')
    ) {
      return strings.purchaseErrorRateLimit || strings.error;
    }

    if (
      raw.includes('paquete') ||
      raw.includes('bundle') ||
      raw.includes('pack') ||
      raw.includes('del paquete')
    ) {
      return strings.purchaseErrorBundle || strings.error;
    }

    if (
      raw.includes('agotado') ||
      raw.includes('sold out') ||
      raw.includes('out of stock') ||
      raw.includes('esgotado')
    ) {
      return strings.purchaseErrorSoldOut || strings.error;
    }

    return strings.purchaseErrorGeneric || strings.error;
  }

  function isCartCorruptionError(error) {
    const raw = normalizeError(error).toLowerCase();
    return (
      raw.includes('422') ||
      raw.includes('paquete') ||
      raw.includes('bundle') ||
      raw.includes('pack') ||
      raw.includes('del paquete') ||
      raw.includes('agotado') ||
      raw.includes('sold out') ||
      raw.includes('out of stock') ||
      raw.includes('esgotado') ||
      raw.includes('no se puede agregar') ||
      raw.includes('cannot be added')
    );
  }

  function showCartInlineError(message) {
    const el = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
    if (el) el.textContent = message;
  }

  function clearCartAndReload(message) {
    window.alert(message);

    return fetch((window.routes && window.routes.cart_clear_url) || '/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }).finally(() => {
      window.location.reload();
    });
  }

  function handlePurchaseOptionFailure(host, error) {
    const message =
      window.cartStrings?.purchaseOptionClearCart ||
      resolveCartErrorMessage(error);

    if (host) {
      const lineError = host.querySelector('.cart-item__purchase-option-error');
      if (lineError) {
        lineError.textContent = message;
        lineError.hidden = false;
      }
    }

    showCartInlineError(message);
    return clearCartAndReload(message);
  }

  function handlePdpAddFailure(error, productForm) {
    const message =
      window.cartStrings?.purchasePdpClearCart ||
      window.cartStrings?.purchaseOptionClearCart ||
      resolveCartErrorMessage(error);

    if (productForm) {
      const wrapper = productForm.querySelector('.product-form__error-message-wrapper');
      const msgEl = productForm.querySelector('.product-form__error-message');
      if (wrapper && msgEl) {
        wrapper.hidden = false;
        msgEl.textContent = message;
      }
    }

    return clearCartAndReload(message);
  }

  function showPurchaseOptionError(host, message) {
    if (host) {
      const lineError = host.querySelector('.cart-item__purchase-option-error');
      if (lineError) {
        lineError.textContent = message;
        lineError.hidden = false;
      }
    }

    showCartInlineError(message);
    window.alert(message);
  }

  function clearPurchaseOptionError(host) {
    if (!host) return;
    const lineError = host.querySelector('.cart-item__purchase-option-error');
    if (!lineError) return;
    lineError.textContent = '';
    lineError.hidden = true;
  }

  function showPurchaseError(message, productForm) {
    if (productForm) {
      const wrapper = productForm.querySelector('.product-form__error-message-wrapper');
      const msgEl = productForm.querySelector('.product-form__error-message');
      if (wrapper && msgEl) {
        wrapper.hidden = false;
        msgEl.textContent = message;
      }
    }

    window.alert(message);
  }

  function clearPurchaseError(productForm) {
    if (!productForm) return;
    const wrapper = productForm.querySelector('.product-form__error-message-wrapper');
    const msgEl = productForm.querySelector('.product-form__error-message');
    if (wrapper) wrapper.hidden = true;
    if (msgEl) msgEl.textContent = '';
  }

  window.RuCartErrors = {
    resolve: resolveCartErrorMessage,
    isCartCorruptionError,
    isPurchaseOptionCartCorruptionError: isCartCorruptionError,
    handlePurchaseOptionFailure,
    handlePdpAddFailure,
    clearCartAndReload,
    showCartInlineError,
    showPurchaseOptionError,
    clearPurchaseOptionError,
    showPurchaseError,
    clearPurchaseError,
  };
})();
